import { useMemo } from 'react';
import queryString from 'query-string';
import { useSelector } from 'react-redux';

export const useInitUrlParameters = () => {
  const initUrlParameters = useSelector((state) => state.main.urlParameters);

  return useMemo(() => queryString.parseUrl(initUrlParameters ?? ''), [initUrlParameters]);
};
